import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-sms-warning',
  templateUrl: './sms-warning.component.html'
})
export class SmsWarningComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SmsWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick(){
    this.dialogRef.close();
  }

  onConfirmClick() {
    this.dialogRef.close("changeToEmail");
  }

}
